import React from 'react'
import Navbar from './Navbar'
import Footer from './Footer'

function Contact() {
    return (
        <div>
            <Navbar></Navbar>
            <Footer></Footer>
        </div>
    )
}

export default Contact